import React, { useEffect } from 'react';
import { Construction } from 'lucide-react';
import PageShell from './PageShell';
import { Link } from 'react-router-dom';

export default function ComingSoon({ eyebrow, title, subtitle }) {
  useEffect(() => { document.title = `${typeof title === 'string' ? title : 'Yakında'} — Aegis Studios`; }, [title]);
  return (
    <PageShell eyebrow={eyebrow || 'YAKINDA'} title={title || <span className="gold-text">Yakında</span>} subtitle={subtitle}>
      <section className="pb-32">
        <div className="max-w-[900px] mx-auto px-6 text-center">
          <div className="inline-flex w-20 h-20 rounded-full bg-[#e4b44e]/10 border border-[#e4b44e]/30 items-center justify-center mb-6">
            <Construction className="w-8 h-8 text-[#f4d896]" />
          </div>
          <h3 className="font-display text-3xl font-black text-white mb-3">Bu sayfa yakında!</h3>
          <p className="text-white/60 mb-8">Bölüm hazırlanıyor. Beklerken diğer içeriklere göz atmak ister misiniz?</p>
          <div className="flex flex-wrap justify-center gap-3">
            <Link to="/products" className="btn-gold h-12 px-6 rounded-full inline-flex items-center text-sm font-extrabold tracking-widest">ÜRÜNLER</Link>
            <Link to="/free-products" className="btn-outline-gold h-12 px-6 rounded-full inline-flex items-center text-sm font-bold tracking-widest">ÜCRETSİZ SİSTEMLER</Link>
            <Link to="/contact" className="btn-outline-gold h-12 px-6 rounded-full inline-flex items-center text-sm font-bold tracking-widest">İLETİŞİM</Link>
          </div>
        </div>
      </section>
    </PageShell>
  );
}
